module.exports = __webpack_public_path__ + "static/img/bannerBg2.75fd02b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bannerBg2.png
// module id = 6+5n
// module chunks = 1